import React from 'react';
import { Content } from './shared';

const AetnaFluShot = () => (
  <Content>
    The following pharmacies offer free flu shots:
    <ul>
      <li>CVS</li>

      <li>Hannaford, Inc.</li>

      <li>HEB Grocery</li>

      <li>Marc's Pharmacies</li>

      <li>Mollen Immunization Clinics</li>

      <li>QuickChek Pharmacies</li>

      <li>Rite Aid Pharmacies</li>

      <li>Safeway</li>

      <li>ShopRite/Wakefern</li>

      <li>SUPERVALU</li>

      <li>Target Pharmacies</li>

      <li>The Little Clinic</li>

      <li>MinuteClinic, Inc.</li>

      <li>RediClinic</li>

      <li>Take Care Health Systems</li>

      <li>Target Clinic Medical Associates</li>
    </ul>
    Note: Be sure to confirm with the provider that they accept your medical plan before receiving
    services.
  </Content>
);

export default AetnaFluShot;
